import { Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const BillStatusBadgeWrapper = styled.div`
  margin-left: auto;
  padding-left: ${Spacing.S12};
`
